import { REGIONS_MUNICIPALITIES_FEATURES } from '@schema/featureToggle'

export const regionsTabsQueryParamName = 'tab'
export const regionalActueelTabsQueryParamName = 'actueelTab'

export const regionsTabs = REGIONS_MUNICIPALITIES_FEATURES

export const regionalActueelTabs = {
  verhalen: 'verhalen',
  news: 'news',
  blog: 'blog',
} as const

/** Tabs shown in the RegionalPageLayout sticky navbar */
export const regionalPageLayoutTabs = {
  home: regionsTabs.overview,
  current: regionsTabs.current,
  discussion: regionsTabs.discussion,
  initiatives: regionsTabs.initiatives,
  municipalities: regionsTabs.municipalities,
  experts: regionsTabs.experts,
  locations: regionsTabs.locations,
  knowledgeHub: regionsTabs.knowledgeHub,
} as const
